import { Avatar, AvatarFallback, AvatarImage } from 'ui';

export function PostAvatar({
  name,
  avatar,
  className,
}: {
  name: string;
  avatar: string;
  className?: string;
}) {
  const isCJK = /[\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff\uac00-\ud7af]/.test(
    name,
  );
  return (
    <Avatar className={className}>
      <AvatarImage alt={name} src={avatar} />
      <AvatarFallback>
        {isCJK ? name.charAt(0) : name.slice(0, 2).toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
}
